import React, { Component } from "react";
import { AlertModal } from "../AlertModal/AlertModal";
import './SolicitacaoComunicacao.css';


export const ModalMensagem = 

class extends Component {

  
	render() {

		const mensagem = this.props.mensagem;

		return (
			<AlertModal visible={this.props.visible} handleClose={this.props.handleClose} width={'80%'} noTitle >
				<div className="container-fluid">
					<div className="br-form">
						<div className="container-body" style={{height: '30vh'}}>
							<div className="row">
								<div className="col-md">  
									<div className="field">
										<div className="input"> 
											<label htmlFor="assunto">Assunto:</label>
											<input type="text" name="assunto" value={mensagem.assunto} readOnly/>
										</div>
									</div>
								</div>
							</div>

							<div className="row">
								<div className="col-md">  
									<div className="field">
										<div className="input"> 
											<label htmlFor="mensagem">Mensagem:</label>
											<textarea name="mensagem" value={mensagem.mensagem} style={{height:"90px"}} readOnly/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>	
			</AlertModal>
		)
	}

}